import React, { FC } from "react";
import TableWrapper from "../../components/table/TableWrapper";
import newListActionTemplate from "./Actions";
import { Application, useFindApplicationListQuery } from "../../api/beachApi";
import TextInput from "../../components/form/TextInput";
import { useAppSelector } from "../../app/hooks";
import { selectSomethingState, setData } from "../../slices/tmpPatternSlice";
import { formatDate } from "../../utils/dateUtils";
import { Badge } from "primereact/badge";

const columns = [
  { hidden: true, field: "firstName", header: "Imię" },
  { hidden: true, field: "lastName", header: "Nazwisko" },
  { field: "name", header: "Imię i nazwisko", body: (row: Application) => row.firstName + " " + row.lastName },
  { field: "pesel", header: "PESEL" },
  { field: "licenceNumber", header: "Numer licencji" },
  { field: "birthdayYear", header: "Rocznik" },
  { field: "clubName", header: "Klub" },
  {
    field: "type",
    header: "Typ wniosku",
    style: { textAlign: "center" },
    body: (row: Application) => <Badge value={row.type === "NEW" ? "Nowy" : "Duplikat"}
                                       style={{ backgroundColor: row.type === "NEW" ? "black" : "orange" }} />
  }, {
    field: "createdDate",
    header: "Złożony",
    body: (row: Application) => row.createdDate ? formatDate(new Date(row.createdDate)) : ""
  },
  { field: "", header: "Akcje", body: newListActionTemplate }
];

const NewList: FC<{}> = ({}) => {
  const { newListFilter } = useAppSelector(selectSomethingState);

  const { data, isLoading } = useFindApplicationListQuery({ status: "NEW" });

  return (
    <>
      <TextInput
        id="filter-new-list"
        name="newListFilter"
        label=""
        value={newListFilter}
        setProperty={setData}
        style={{ width: "100%" }}
        outerStyle={{ marginBottom: 0 }}
      />
      <TableWrapper
        header="Wnioski nowe"
        sortField="createdDate"
        isLoading={isLoading}
        data={data}
        columns={columns}
        filter={newListFilter}
        stateKey={"new-list"}
      />
    </>
  );
};

export default NewList;
